import { render, staticRenderFns } from "./ProjectImpactLink.vue?vue&type=template&id=1a0e47ff&scoped=true&"
import script from "./ProjectImpactLink.vue?vue&type=script&lang=js&"
export * from "./ProjectImpactLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0e47ff",
  null
  
)

export default component.exports